/* LoveDK custom front-end behaviour.
   Swipe-gallery dots for product cards (.ldk-card / .product-card--ldk).
   Uses capture-phase scroll delegation so it also covers cards added later by
   AJAX (collection filtering, load-more, quick view, etc.) without re-binding. */
(function () {
  function updateDots(gallery) {
    var media = gallery.closest('.ldk-card__media') || gallery.parentElement;
    if (!media) return;
    var dots = media.querySelectorAll('.ldk-card__dot');
    if (!dots.length) return;
    var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === idx);
    }
  }

  document.addEventListener(
    'scroll',
    function (e) {
      var g = e.target;
      if (!g || !g.classList || !g.classList.contains('ldk-card__gallery')) return;
      if (g._ldkRaf) return;
      g._ldkRaf = requestAnimationFrame(function () {
        updateDots(g);
        g._ldkRaf = null;
      });
    },
    true
  );
})();
